var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc20OpenInNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M5 2h2a1 1 0 0 1 .117 1.993L7 4H5a1 1 0 0 0-.993.883L4 5v10a1 1 0 0 0 .883.993L5 16h10a1 1 0 0 0 .993-.883L16 15v-2a1 1 0 0 1 1.993-.117L18 13v2a3 3 0 0 1-2.824 2.995L15 18H5a3 3 0 0 1-2.995-2.824L2 15V5a3 3 0 0 1 2.824-2.995L5 2h2-2Zm12 0 .081.003.12.017.111.03.111.044.098.052.096.067.09.08.097.112.071.11.031.062.034.081.024.076.03.148L18 3v4a1 1 0 1 1-2 0V5.414l-4.293 4.293a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094L14.584 4H13a1 1 0 1 1 0-2h4Z",
  clipRule: "evenodd"
})));
export default SvgIc20OpenInNew;